exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#wrapper[data-v-3d4d89fd] {\n  min-height: 80vh;\n}\n", ""]);
